import { useCallback } from 'react'
import { AddRecentSearch, RecentSearch } from '../../../common/types/search'

type UseRecentSearchHandlersProps = {
  setValue: (name: 'searchInput', value: string) => void
  setGroupToSearch: (group: string | undefined) => void
  setUserDismissedChip: (dismissed: boolean) => void
  addRecentSearch: AddRecentSearch
}

export const useRecentSearchHandlers = ({
  setValue,
  setGroupToSearch,
  setUserDismissedChip,
  addRecentSearch,
}: UseRecentSearchHandlersProps) => {
  const handleRecentSearchClick = useCallback(
    (recentSearch: RecentSearch) => {
      if (recentSearch.type === 'query') {
        setValue('searchInput', recentSearch.value)
        addRecentSearch([{ type: 'query', value: recentSearch.value }])
      } else if (recentSearch.type === 'group') {
        setGroupToSearch(recentSearch.value)
        setUserDismissedChip(false)
        if (recentSearch.searchValue?.trim()) {
          setValue('searchInput', recentSearch.searchValue.trim())
        }
        addRecentSearch([
          {
            type: 'group',
            title: recentSearch.title,
            value: recentSearch.value,
            avatarSrc: recentSearch.avatarSrc,
            searchValue: recentSearch.searchValue,
          },
        ])
      }
    },
    [setValue, setGroupToSearch, setUserDismissedChip, addRecentSearch],
  )

  return { handleRecentSearchClick }
}
